import {
  Box,
  Container,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Grid,
  IconButton,
  Drawer,
  TextField,
  FormControlLabel,
  Switch,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Button,
  Checkbox,
  Radio,
  RadioGroup,
  Alert,
  FormLabel,
  Rating,
  Slider,
  LinearProgress,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  Paper,
  Card,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, { useEffect, useMemo, useState } from "react";
import PageTitle from "../../widgets/PageTitle";
import SaveIcon from "@mui/icons-material/Save";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import RttIcon from "@mui/icons-material/Rtt";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import DownloadDoneOutlinedIcon from "@mui/icons-material/DownloadDoneOutlined";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { LoadingButton } from "@mui/lab";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import TopTitleActions from "../../widgets/TopTitleActions";
import { useParams } from "react-router-dom";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import {
  getErrorResponse,
  getHeader,
  toCamelCase,
  toastError,
} from "../../utils/util";
import BackBtn from "../../widgets/BackBtn";
import TitleActionsContainer from "../../widgets/TitleActionsContainer";
import SectionLabel from "../../widgets/SectionLabel";
import { API_ENDPOINT } from "../../utils/constants";
import { text } from "d3";
import axios from "axios";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { toast } from "react-toastify";
import MyDatePicker from "../../widgets/MyDatePicker";
const TEXT_TYPES = ["TextHeading", "TextSubheading", "TextCaption", "TextBody"];
const TEXT_LIMITS = {
  TextHeading: 80,
  TextSubheading: 80,
  TextBody: 4096,
  TextCaption: 409,
};
const INPUT_TYPES = ["text", "number", "email", "password", "phone"];
export const AVAILABLE_FIELDS = [
  {
    id: "Text",
    type: "Text",
    label: "Text",
    icon: <FormatColorTextIcon />,
  },
  {
    id: "TextInput",
    type: "TextInput",
    label: "Text Input",
    icon: <TextFieldsIcon />,
  },
  {
    id: "CheckboxGroup",
    type: "CheckboxGroup",
    label: "Checkbox group",
    icon: <CheckBoxOutlineBlankOutlinedIcon />,
  },
  {
    id: "RadioButtonsGroup",
    type: "RadioButtonsGroup",
    label: "Radio Buttons Group",
    icon: <RadioButtonUncheckedOutlinedIcon />,
  },
  {
    id: "Dropdown",
    type: "Dropdown",
    label: "Dropdown",
    icon: <ArrowDropDownCircleOutlinedIcon />,
  },
  {
    id: "CalendarPicker",
    type: "CalendarPicker",
    label: "Date Picker",
    icon: <CalendarTodayIcon />,
  },
  {
    id: "Footer",
    type: "Footer",
    label: "Footer",
    icon: <SquareFootIcon />,
  },
];
export function getBasicTextVariant(basicType) {
  switch (basicType) {
    case "TextHeading":
      return "h5";
    case "TextSubheading":
      return "h6";
    case "TextCaption":
      return "caption";
    case "TextBody":
      return "body1";
    default:
      return "";
  }
}
const getDefaultProperties = (type) => {
  switch (type) {
    case "Text":
      return {
        label: "TextHeading",
        placeholder: "TextHeading",
        text: TEXT_TYPES[0],
        subType: TEXT_TYPES[0],
      };
    case "TextInput":
      return {
        label: "TextInput",
        placeholder: "TextInput",
        "input-type": INPUT_TYPES[0],
        required: true,
      };
    case "CheckboxGroup":
      return { label: "Checkbox group", "data-source": [], required: true };
    case "RadioButtonsGroup":
      return {
        label: "RadioButtonsGroup",
        "data-source": [],
        required: true,
      };
    case "Dropdown":
      return { label: "Dropdown", "data-source": [], required: true };
    case "CalendarPicker":
      return { label: "Date Picker", required: true };
    case "Footer":
      return { label: "Footer", name: "complete" };
    default:
      return {};
  }
};
const updateAllFootersAndCleanFields = (screens) => {
  return screens.map((screen, index) => {
    const isLastScreen = index === screens.length - 1;
    const children = screen.layout?.children || [];

    const updatedChildren = children.map((child) => {
      // 1. Remove id only from root field object
      const { id, subType, ...cleanField } = child;

      // 2. Handle Text field type conversion
      if (cleanField.type === "Text" && subType) {
        cleanField.type = subType;
      }

      // 3. Special handling for Footer fields
      if (cleanField.type === "Footer") {
        const payload = {};
        if (isLastScreen) {
          screens.forEach((scr, scrIndex) => {
            if (scr.layout?.children) {
              scr.layout.children.forEach((field) => {
                if (field.name) {
                  if (scrIndex < index) {
                    payload[
                      field.name
                    ] = `\${screen.${scr.id}.form.${field.name}}`;
                  } else if (scrIndex === index) {
                    payload[field.name] = `\${form.${field.name}}`;
                  }
                }
              });
            }
          });
        }

        return {
          ...cleanField,
          "on-click-action": {
            name: isLastScreen ? "complete" : "navigate",
            ...(!isLastScreen && {
              next: {
                type: "screen",
                name: screens[index + 1]?.id || "",
              },
            }),
            ...(isLastScreen && { payload }),
          },
        };
      }
      return cleanField;
    });

    return {
      ...screen,
      layout: {
        ...screen.layout,
        children: updatedChildren,
      },
    };
  });
};
const FlowForms = () => {
  const [openForm, setOpenForm] = useState(false);
  const [submittingData, setSubmittingData] = useState(false);
  const [savingDraft, setSavingDraft] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
  });
  const [errors, setErrors] = useState({
    title: "",
  });
  const [submitStatus, setSubmitStatus] = useState({
    success: false,
    message: "",
  });
  const [currentScreen, setCurrentScreen] = useState(0);
  const { id } = useParams();
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/api/get-flow-asset/${id}`
  );
  const [formFields, setFormFields] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedFieldId, setSelectedFieldId] = useState(null);
  const [availableFields, setAvailableFields] = useState(AVAILABLE_FIELDS);
  const screens = useMemo(() => {
    return data?.json?.screens;
  }, [data?.json?.screens]);

  useEffect(() => {
    if (data) {
      const screen = data.json.screens[currentScreen];
      const fields = screen.layout.children;
      fields.forEach((item) => {
        item.id = uuidv4();
        if (TEXT_TYPES.includes(item.type)) {
          item.subType = item.type;
          item.type = "Text";
        }
        if (
          item.type === "CheckboxGroup" ||
          item.type === "Dropdown" ||
          item.type === "RadioButtonsGroup"
        ) {
          item["data-source"] = item["data-source"].map((item) => item.title);
        }
      });
      setFormFields(fields);
    }
  }, [data, currentScreen]);
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  const handleOpen = () => {
    setOpenForm(true);
    setSubmitStatus({ success: false, message: "" });
  };

  const handleClose = () => {
    setOpenForm(false);
    setFormData({ title: "" });
    setErrors({ title: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validatedValue = value.replace(/[^a-zA-Z0-9_ ]/g, "");
    const limitedValue = validatedValue.slice(0, 30);
    setFormData((prev) => ({ ...prev, [name]: limitedValue }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const validateForm = () => {
    let valid = true;
    const newErrors = { title: "" };
    if (!formData.title) {
      newErrors.title = "Title is required";
      valid = false;
    } else if (formData.title.length > 30) {
      newErrors.title = "Title must be 30 characters or less";
      valid = false;
    } else if (!/^[a-zA-Z0-9 ]+$/.test(formData.title)) {
      newErrors.title = "Title can only contain letters, numbers, and spaces";
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    const formJson = data.json;
    const newScreen = {
      id: toCamelCase(formData.title),
      title: formData.title,
      terminal: true,
      data: {},
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Footer",
            label: "Complete",
            "on-click-action": {
              name: "complete",
              payload: {},
            },
          },
        ],
      },
    };
    formJson.screens.push(newScreen);

    try {
      setSubmittingData(true);
      const response = await axios.post(
        `${API_ENDPOINT}/api/update-flow-json/${id}`,
        formData,
        getHeader()
      );
      toast.success(response.data.message);
      setTimeout(() => {
        handleClose();
      }, 200);
    } catch (error) {
      toastError(error);
    } finally {
      setSubmittingData(false);
    }
  };

  const updateFieldProperties = (fieldId, newProperties) => {
    setFormFields((prevFields) =>
      prevFields.map((field) =>
        field.id === fieldId ? { ...field, ...newProperties } : field
      )
    );
  };
  const handleFieldEdit = (fieldId) => {
    setSelectedFieldId(fieldId);
    setIsDrawerOpen(true);
  };

  const handleFieldDelete = (fieldId) => {
    setFormFields((prev) => prev.filter((f) => f.id !== fieldId));
  };
  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (destination.droppableId !== "formFields") return;

    if (source.droppableId === "availableFields") {
      const sourceField = availableFields[source.index];
      const newField = {
        id: uuidv4(),
        type: sourceField.type,
        ...getDefaultProperties(sourceField.type),
      };
      const newFormFields = Array.from(formFields);
      newFormFields.splice(destination.index, 0, newField);
      setFormFields(newFormFields);
    } else {
      const reorderedFields = Array.from(formFields);
      const [movedField] = reorderedFields.splice(source.index, 1);
      reorderedFields.splice(destination.index, 0, movedField);
      setFormFields(reorderedFields);
    }
  };
  //only for render in browser
  const renderFormElement = (field) => {
    const { label, type, text } = field;
    switch (type) {
      case "Text":
        return (
          <Typography variant={getBasicTextVariant(field.subType)}>
            {text}
          </Typography>
        );
      case "TextInput":
        return (
          <TextField
            type={field["input-type"]}
            fullWidth
            size="small"
            label={label}
            variant="outlined"
          />
        );
      case "CheckboxGroup":
        return (
          <FormControl component="fieldset" variant="standard">
            <FormLabel component="legend">{label}</FormLabel>
            <FormGroup>
              {field["data-source"].map((item, index) => (
                <FormControlLabel
                  key={index}
                  control={<Checkbox value={item} />}
                  label={item}
                />
              ))}
            </FormGroup>
          </FormControl>
        );
      case "Dropdown":
        return (
          <FormControl size="small" fullWidth>
            <InputLabel id="demo-simple-select-label">{label}</InputLabel>
            <Select
              label={label}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
            >
              {field["data-source"].map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      case "RadioButtonsGroup":
        return (
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">{label}</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              {field["data-source"].map((item, index) => (
                <FormControlLabel
                  key={index}
                  value={item}
                  control={<Radio />}
                  label={item}
                />
              ))}
            </RadioGroup>
          </FormControl>
        );
      case "CalendarPicker":
        return <MyDatePicker label={label} />;

      case "Footer":
        return (
          <Button fullWidth variant="contained" size="small">
            {label}
          </Button>
        );
      default:
        return <Typography variant="body2">{field.type}</Typography>;
    }
  };
  const renderEditingPanel = () => {
    const field = formFields.find((f) => f.id === selectedFieldId);
    if (!field) return null;

    const { type, label } = field;

    const handlValueChange = (propName, newV) => {
      updateFieldProperties(field.id, { [propName]: newV });
    };
    const handlePropertyChange = (propName) => (event) => {
      const value =
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value;
      console.log(field.id, propName, value, field);
      updateFieldProperties(field.id, { [propName]: value });
    };
    const handleOptionsChange = (index) => (event) => {
      const newOptions = [...field["data-source"]];
      newOptions[index] = event.target.value;
      updateFieldProperties(field.id, { "data-source": newOptions });
    };
    const addOption = () => {
      updateFieldProperties(field.id, {
        "data-source": [...field["data-source"], ""],
      });
    };

    const removeOption = (index) => {
      const newOptions = field["data-source"].filter((_, i) => i !== index);
      updateFieldProperties(field.id, { "data-source": newOptions });
    };
    const IsRequiredWidget = ({ label, id }) => {
      return (
        <FormControlLabel
          sx={{ ml: 0 }}
          control={
            <Switch
              size="small"
              checked={field[id]}
              onChange={handlePropertyChange(id)}
            />
          }
          label={label}
        />
      );
    };
    return (
      <Box p={2}>
        {!TEXT_TYPES.includes(field.subType) && (
          <TextField
            size="small"
            label="Field name"
            value={label}
            onChange={handlePropertyChange("label")}
            fullWidth
            margin="normal"
          />
        )}

        {TEXT_TYPES.includes(field.subType) && (
          <Stack my={2} spacing={2}>
            <TextField
              size="small"
              label={`Enter Text value`}
              value={field.text}
              onChange={handlePropertyChange("text")}
              fullWidth
              margin="normal"
            />
            <FormControl size="small" fullWidth>
              <InputLabel>Select Text type</InputLabel>
              <Select
                label="Select Text type"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={field.subType}
                onChange={handlePropertyChange("subType")}
              >
                {TEXT_TYPES.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        )}

        {type === "TextInput" && (
          <Box my={2}>
            <FormControl size="small" fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Text type
              </InputLabel>
              <Select
                label="Select Text type"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={field["input-type"]}
                onChange={handlePropertyChange("input-type")}
              >
                {INPUT_TYPES.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}

        {!TEXT_TYPES.includes(field.subType) && type !== "Footer" && (
          <Box>
            <IsRequiredWidget label={"Required?"} id={"required"} />
          </Box>
        )}
        {(type === "CheckboxGroup" ||
          type === "RadioButtonsGroup" ||
          type === "Dropdown") && (
          <Box mt={2}>
            <SectionLabel>Add options</SectionLabel>
            {field["data-source"].map((option, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  marginTop: "10px",
                  marginBottom: "16px",
                  alignItems: "center",
                }}
              >
                <TextField
                  inputProps={{
                    maxLength: 128,
                  }}
                  size="small"
                  value={option}
                  label={`Option ${index + 1}`}
                  onChange={(e) => {
                    const validatedValue = e.target.value.replace(
                      /[^a-zA-Z0-9_ ]/g,
                      ""
                    );
                    const limitedValue = validatedValue.slice(0, 128);
                    handleOptionsChange(index)({
                      target: { value: limitedValue },
                    });
                  }}
                  fullWidth
                />
                <IconButton
                  size="small"
                  onClick={() => removeOption(index)}
                  color="secondary"
                  aria-label="remove option"
                >
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </div>
            ))}
            <Box display={"flex"} justifyContent={"end"}>
              <Button
                startIcon={<AddIcon />}
                size="small"
                variant="outlined"
                onClick={addOption}
                color="primary"
              >
                Add
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    );
  };
  const handleSaveDraft = async () => {
    const jsonToSubmit = {
      ...data.json,
    };
    const screenToUpdate = jsonToSubmit.screens[currentScreen];

    const fields = [];
    formFields.forEach((item) => {
      switch (item.type) {
        case "Text":
          fields.push({
            type: item.subType,
            text: item.text,
          });
          break;
        case "TextInput":
          fields.push({
            type: "TextInput",
            required: true,
            label: item.label,
            name: toCamelCase(item.label),
            "input-type": item["input-type"],
          });
          break;
        case "CheckboxGroup":
          fields.push({
            type: "CheckboxGroup",
            label: item.label,
            name: toCamelCase(item.label),
            "data-source": item["data-source"]
              .filter((ds) => ds !== "")
              .map((ds) => ({ id: toCamelCase(ds), title: ds })),
          });
          break;
        case "Dropdown":
          fields.push({
            type: "Dropdown",
            label: item.label,
            name: toCamelCase(item.label),
            "data-source": item["data-source"]
              .filter((ds) => ds !== "")
              .map((ds) => ({ id: toCamelCase(ds), title: ds })),
          });
          break;
        case "RadioButtonsGroup":
          fields.push({
            type: "RadioButtonsGroup",
            label: item.label,
            name: toCamelCase(item.label),
            "data-source": item["data-source"]
              .filter((ds) => ds !== "")
              .map((ds) => ({ id: toCamelCase(ds), title: ds })),
          });
          break;
        case "CalendarPicker":
          fields.push({
            type: "CalendarPicker",
            name: toCamelCase(item.label),
            label: item.label,
            "helper-text": "Select a date",
            required: true,
          });
          break;
        case "Footer":
          const isLastScreen =
            jsonToSubmit.screens.length === currentScreen + 1;
          let payload = {};
          if (isLastScreen) {
            // Add fields from all previous screens
            jsonToSubmit.screens.forEach((screen, index) => {
              if (screen.layout && screen.layout.children) {
                screen.layout.children.forEach((child) => {
                  if (child.name) {
                    // Only include components that have a name property
                    // For previous screens, use screen reference
                    if (index < currentScreen) {
                      payload[
                        child.name
                      ] = `\${screen.${screen.id}.form.${child.name}}`;
                    }
                    // For current screen, use direct form reference
                    else if (index === currentScreen) {
                      payload[child.name] = `\${form.${child.name}}`;
                    }
                  }
                });
              }
            });
          }
          const actionObject = {
            name: isLastScreen ? "complete" : "navigate",
            ...(!isLastScreen && {
              next: {
                type: "screen",
                name: jsonToSubmit.screens[currentScreen + 1].id,
              },
            }),
            ...(isLastScreen && { payload }),
          };

          fields.push({
            type: "Footer",
            label: item.label,
            "on-click-action": actionObject,
          });
          break;
        default:
          break;
      }
    });
    screenToUpdate.layout = {
      type: "SingleColumnLayout",
      children: fields,
    };
    jsonToSubmit.screens[currentScreen] = screenToUpdate;
    jsonToSubmit.screens = updateAllFootersAndCleanFields(jsonToSubmit.screens);

    try {
      setSavingDraft(true);
      const response = await axios.post(
        `${API_ENDPOINT}/api/update-flow-json/${id}`,
        jsonToSubmit,
        getHeader()
      );
      toast.success(response.data.message);
      setTimeout(() => {
        handleClose();
      }, 200);
    } catch (error) {
      toastError(error);
    } finally {
      setSavingDraft(false);
    }
  };
  return (
    <Container sx={{ mt: 3 }}>
      <BackBtn />
      <TitleActionsContainer>
        <PageTitle>Flow Builder</PageTitle>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          <FormControl size="small" fullWidth>
            <InputLabel id="demo-simple-select-label">Screen</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Screen"
              value={currentScreen}
              onChange={(e) => setCurrentScreen(e.target.value)}
            >
              {screens?.map((screen, index) => (
                <MenuItem key={screen.id} value={index}>
                  {screen.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <LoadingButton
            sx={{ width: 220 }}
            size="small"
            variant="outlined"
            onClick={handleOpen}
            startIcon={<EditIcon />}
          >
            Add Screen
          </LoadingButton>
          <LoadingButton
            sx={{ width: 220 }}
            size="small"
            variant="outlined"
            loading={savingDraft}
            onClick={handleSaveDraft}
            startIcon={<SaveIcon />}
          >
            Save Draft
          </LoadingButton>
        </Stack>
      </TitleActionsContainer>
      <Paper variant="outlined" sx={{ p: 3, mt: 2 }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Droppable droppableId="availableFields" isDropDisabled>
                {(provided) => (
                  <Box ref={provided.innerRef} {...provided.droppableProps}>
                    <Typography variant="h6">Available Fields</Typography>
                    {availableFields.map((field, index) => (
                      <Draggable
                        key={field.id}
                        draggableId={field.id}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              padding: "12px 8px",
                              margin: "8px 4px",
                              border: "1px solid #ddd",
                              background:
                                "linear-gradient(90deg, #f8fafc 0%, rgb(192 208 241) 50%, #f1e8f7 100%)",
                              borderRadius: "4px",
                              cursor: "grab",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {field.icon}
                            <Typography
                              variant="body1"
                              style={{ marginLeft: "8px" }}
                            >
                              {field.label}
                            </Typography>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </Grid>
            <Grid item xs={12} md={9}>
              <Typography variant="h6">{data?.detail?.name}</Typography>
              <Card variant="outlined" sx={{ p: 1, m: 1 }}>
                <Droppable droppableId="formFields">
                  {(provided) => (
                    <Grid
                      container
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {formFields.length === 0 && (
                        <Typography m={2} variant="body1" color="textSecondary">
                          Drag form fields here to build your form
                        </Typography>
                      )}

                      {formFields.map((field, index) => (
                        <Draggable
                          key={field.id}
                          draggableId={field.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <Grid
                              item
                              xs={
                                field?.properties?.grid
                                  ? parseInt(field.properties.grid, 10)
                                  : 12
                              }
                            >
                              <Box
                                m={1}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={provided.draggableProps.style}
                              >
                                <div
                                  {...provided.dragHandleProps}
                                  style={{
                                    padding: "8px",
                                    marginBottom: "8px",
                                    backgroundColor: snapshot.isDragging
                                      ? "#e0f7fa"
                                      : "#fff",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "grab",
                                  }}
                                >
                                  <Box flex={1}>{renderFormElement(field)}</Box>
                                  <div
                                    style={{
                                      marginLeft: "auto",
                                      opacity: 0.7,
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <IconButton
                                      size="small"
                                      onClick={() => handleFieldEdit(field.id)}
                                      aria-label="edit"
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleFieldDelete(field.id)
                                      }
                                      aria-label="delete"
                                    >
                                      <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                  </div>
                                </div>
                              </Box>
                            </Grid>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Grid>
                  )}
                </Droppable>
              </Card>
            </Grid>
          </Grid>
        </DragDropContext>
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          sx={{ "& .MuiDrawer-paper": { width: 550 }, zIndex: 1201 }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1,
              px: 2,
              borderBottom: "1px solid #ddd",
            }}
          >
            <Typography variant="h6">Edit Selected field</Typography>
            <IconButton onClick={() => setIsDrawerOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          {renderEditingPanel()}
        </Drawer>
      </Paper>
      <Dialog open={openForm} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Screen Data</DialogTitle>
        <DialogContent>
          {submitStatus.message && (
            <Alert
              severity={submitStatus.success ? "success" : "error"}
              sx={{ mb: 2 }}
            >
              {submitStatus.message}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="title"
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              error={!!errors.title}
              helperText={
                errors.title || "Max 30 characters. Only letters and spaces."
              }
              inputProps={{ maxLength: 30 }}
              placeholder="Screen Title"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            loading={submittingData}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default FlowForms;
